import { render, staticRenderFns } from "./PendingList.vue?vue&type=template&id=75f3c70b"
import script from "./PendingList.js?vue&type=script&lang=js&external"
export * from "./PendingList.js?vue&type=script&lang=js&external"
import style0 from "./PendingList.vue?vue&type=style&index=0&id=75f3c70b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports